// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Data_Nullable from "../Data.Nullable/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Restaumatic_Analytics_Tracking_AnalyticsV4 from "../Restaumatic.Analytics.Tracking.AnalyticsV4/index.js";
import * as Restaumatic_Analytics_Tracking_Event from "../Restaumatic.Analytics.Tracking.Event/index.js";
import * as Restaumatic_Analytics_Tracking_Facebook from "../Restaumatic.Analytics.Tracking.Facebook/index.js";
import * as Utils_Tracking_AnalyticsV3 from "../Utils.Tracking.AnalyticsV3/index.js";
var toNamedEvent = function (currency) {
    return function (ev) {
        return {
            analytics_v3: Data_Nullable.toNullable(Utils_Tracking_AnalyticsV3.toPlatformEvent(currency)(ev)),
            analytics_v4: Data_Nullable.notNull(Restaumatic_Analytics_Tracking_AnalyticsV4.toPlatformEvent(currency)(ev)),
            facebook_v2: Data_Nullable.toNullable(Restaumatic_Analytics_Tracking_Facebook.toPlatformEvent(currency)(ev)),
            restaumatic: Restaumatic_Analytics_Tracking_Event.toPlatformEvent(ev)
        };
    };
};
var trackEvent = function (dictMonadEffect) {
    return function (event) {
        return Effect_Class.liftEffect(dictMonadEffect)(function __do() {
            var currency = $foreign.getCurrencyEff();
            return $foreign.trackEventEff(toNamedEvent(currency)(event))();
        });
    };
};
var trackEventUnique = function (dictMonadEffect) {
    return function (eventKey) {
        return function (event) {
            return Effect_Class.liftEffect(dictMonadEffect)(function __do() {
                var currency = $foreign.getCurrencyEff();
                return $foreign.trackEventUniqueEff(eventKey)(toNamedEvent(currency)(event))();
            });
        };
    };
};
export {
    trackEvent,
    trackEventUnique
};
export {
    AddToCart,
    BeginCheckout,
    LocateMe,
    Purchase,
    RemoveFromCart,
    SetCheckoutOption,
    nonPromotionalCategory,
    promotionalCategory,
    toPlatformEvent
} from "../Restaumatic.Analytics.Tracking.Event/index.js";
//# sourceMappingURL=index.js.map
